import React, { useEffect, useRef, useState } from "react";
import { Table, Modal, Alert } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { baseUrl, domainStudent } from "../../../../services/config";
import Pagination from "@material-ui/lab/Pagination";
import { Paper } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import usePagination from "../../../../components/usePagination/usePagination";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import { upperCase } from "lodash";
import ReactToPrint from "react-to-print";

function HifzProgressReport() {
  const authtoken = localStorage.getItem("userToken");
  const getBranchUrl = localStorage.getItem("branchUrl");
  const user = useSelector((state) => state.user.user);
  const alert = useAlert();
  const [students, setstudents] = useState([]);
  const [campus, setCampus] = useState(user.campuses || []);
  const [campuses, setallcampuses] = useState([]);
  const [classesData, setClassesData] = useState([]);
  const [classes, setClasses] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setloading] = useState(false);
  const [selectedCampus, setSelectedCampus] = useState("");
  const [selectedStudent, setSelectedStudent] = useState({});
  const [sessionData, setSessionData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [educationType, setEducationType] = useState(2);
  const [showModal, setShowModal] = useState(false);
  const [yearId, setYearId] = useState("");
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  //printing states
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const onBeforeGetContentResolve = React.useRef(null);
  const componentRef = useRef(null);

  const pageStyle = `
  @font-face {
    font-family: 'Jameel Noori Nastaleeq';
    src: local("Jameel Noori Nastaleeq"), url('/src/app/fonts/JameelNooriNastaleeqRegular.ttf') format('truetype');
  }

  @page {
    margin-left: 1.5in;
    size: legal landscape !important;
  }

  body {
    font-family: 'Jameel Noori Nastaleeq', serif;
    direction: rtl;
  }
`;

  const headCellStyle = {
    fontSize: "20px",
    border: "1px solid black",
    padding: "1px",
    whiteSpace: "noraml",
    color: "black",
    textAlign: "center",
  };

  const bodyCellStyle = {
    fontSize: "14px", // Reduce if needed
    border: "1px solid black",
    padding: "0px 2px", // Less vertical padding
    lineHeight: "1.2", // Tighter line spacing
    whiteSpace: "normal",
    color: "black",
  };

  const englishText = {
    fontFamily: "'Poppins', sans-serif",
    // textDecoration: "underline",
    color: "black",
    borderBottom: "1px solid black",
    padding: "1px",
  };

  const [addHifzModal, setAddHifzModal] = useState(false);
  const [hifzEndClassId, setHifzEndClassId] = useState("");
  const [previousSchool, setPreviousSchool] = useState("");
  const [previousHifzParay, setPreviousHifzParay] = useState("");
  const [hifzQuranDuration, setHifzQuranDuration] = useState("");
  const [principleRemarks, setPrincipleRemarks] = useState("");
  const [completionDate, setCompletionDate] = useState("");

  const [studentRecordsData, setStudentRecordData] = useState([]);
  const [studentProgessData, setStudentProgessData] = useState([]);
  const [isallfields, setisallfields] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const [paraNumber, setParaNumber] = useState("");
  const [durationAccordingToMap, setDurationAccordingToMap] = useState("");
  const [lessonQuantity, setLessonQuantity] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [extraTimeReason, setExtraTimeReason] = useState("");
  const [numberOfAbsents, setNumberOfAbsents] = useState("");
  const [numberOfAbsentsInLessons, setNumberOfAbsentsInLessons] = useState("");
  const [remarks, setRemarks] = useState("");

  const [editModal, setEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const [editProgressID, setEditProgressID] = useState("");
  const [editParaNumber, setEditParaNumber] = useState("");
  const [editDurationAccordingToMap, setEditDurationAccordingToMap] = useState(
    ""
  );
  const [editLessonQuantity, setEditLessonQuantity] = useState("");
  const [editStartDate, setEditStartDate] = useState("");
  const [editEndDate, setEditEndDate] = useState("");
  const [editExtraTimeReason, setEditExtraTimeReason] = useState("");
  const [editNumberOfAbsents, setEditNumberOfAbsents] = useState("");
  const [
    editNumberOfAbsentsInLessons,
    setEditNumberOfAbsentsInLessons,
  ] = useState("");
  const [editRemarks, setEditRemarks] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteableProgress, setDeleteableProgress] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [printEmpty, setPrintEmpty] = useState(false);

  useEffect(() => {
    sessions();
    getAllCampus();
    getClasses();
    getSettingData();
  }, []);

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/get-all-campuses`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallcampuses(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getClasses = () => {
    fetch(`${baseUrl}/studentclass`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.payload) {
          setClassesData(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = async (id) => {
    setSelectedCampus(id);
    getCampusClasses(id);
    setClasses([]);
    setSelectedClass("");
    setSectionData([]);
    setSelectedSection("");
  };

  const getCampusClasses = (id) => {
    fetch(`${baseUrl}/campusclass/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.payload) {
          setClasses(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onClassChange = (id) => {
    setSelectedClass(id);
    setSectionData([]);
    setSelectedSection("");
    fetch(`${baseUrl}/class_section/${selectedCampus}/${educationType}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSectionData(data.payload);
      })
      .catch((err) => {
        console.log("", err);
      });
  };

  const getStudentRecord = async (id) => {
    setStudentProgessData([]);
    await fetch(`${baseUrl}/search-hifz-student/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setStudentRecordData(data.payload[0] || []);
        setHifzEndClassId(data.payload[0]?.hifz_end_class_id || "");
        setPreviousSchool(data.payload[0]?.previous_school || "");
        setPreviousHifzParay(data.payload[0]?.previous_hifz_paray || "");
        setHifzQuranDuration(data.payload[0]?.hifz_quran_duration || "");
        setPrincipleRemarks(data.payload[0]?.principle_remarks || "");
        setCompletionDate(data.payload[0]?.completion_date || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getStudentProgess = async (admId) => {
    setStudentProgessData([]);
    await fetch(`${baseUrl}/search-hifz-exam-student-progress/${admId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data.payload.length === 0) {
            alert.error("No Record found");
          }
          setStudentProgessData(data.payload);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg[0]);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const goToViewModal = (student) => {
    setSelectedStudent(student);
    getStudentRecord(student?.id);
    getStudentProgess(student.admission_id);
    setShowModal(true);
  };

  // For Print
  const handleAfterPrint = React.useCallback(() => {}, []);

  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(students.length / PER_PAGE);
  const _DATA = usePagination(students, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!searchText) {
      alert.error("Please enter Admission Id or Name");
      return;
    }
    searchByRegId(searchText);
  };

  const searchByRegId = (searchtext) => {
    setloading(true);

    if (searchtext == "") {
      alert.error("Please enter Admission Id or Name");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };

      fetch(`${baseUrl}/search_by_name_or_adm_id_for_hifz`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
          branchUrl: getBranchUrl,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              setloading(false);
              alert.error("Match not found");
            }
            setloading(false);
            setstudents(data.payload);
          } else if (!data.metadata.success) {
            setloading(false);
            alert.error(data.metadata.message);
          }
        })
        .catch((err) => {
          setloading(false);
          console.log("err is re", err);
        });
    }
  };

  const handleShow = () => {
    setSearchText("");
    if (selectedCampus == "") {
      alert.error("Campus is required");
      return;
    }
    let data = {
      campus_id: selectedCampus,
      student_class_id: selectedClass,
      global_section_id: selectedSection,
      status: 2,
      education_type: educationType,
      year_id: yearId,
    };
    setloading(true);

    fetch(`${baseUrl}/student_filter_list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          // console.log(data);
          if (data.metadata) {
            if (data.metadata.success) {
              let res = data.payload.sort(
                (a, b) => a.admission_id - b.admission_id
              );
              let temparr = res;
              res.map((item, index) => {
                item["SrNo"] = index + 1;
                temparr[index] = item;
              });

              setstudents(temparr);
            }
          }
          setloading(false);
        })
      )

      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  const addHifzRecord = async () => {
    setAddLoading(true);
    const data = {
      student_id: selectedStudent?.id,
      hifz_end_class_id: hifzEndClassId,
      previous_school: previousSchool,
      previous_hifz_paray: previousHifzParay,
      hifz_quran_duration: hifzQuranDuration,
      principle_remarks: principleRemarks,
      completion_date: completionDate,
    };

    await fetch(`${baseUrl}/hifz-students`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setAddLoading(false);
            setAddHifzModal(false);
            alert.success("Add Student Record Successfully!!");
            if (searchText != "") {
              searchByRegId(searchText);
            } else {
              handleShow();
            }
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setAddLoading(false);
            setAddHifzModal(false);
          } else {
            alert.error("Something Went Wrong");
            setAddLoading(false);
            setAddHifzModal(false);
          }
        })
      )
      .catch((err) => {
        setAddLoading(false);
        setAddHifzModal(false);
        console.log(err);
      });
  };

  const addProgress = async () => {
    if (
      paraNumber == "" ||
      durationAccordingToMap == "" ||
      lessonQuantity == "" ||
      startDate == "" ||
      endDate == "" ||
      extraTimeReason == "" ||
      numberOfAbsents == "" ||
      numberOfAbsentsInLessons == ""
    ) {
      setisallfields(true);
      return;
    }
    setAddLoading(true);
    setisallfields(false);
    const data = {
      student_id: selectedStudent?.id,
      year_id: selectedStudent.session_id,
      campus_id: selectedStudent.campus_id,
      student_class_id: selectedStudent.student_class_id,
      global_section_id: selectedStudent.global_section_id,
      para_number: paraNumber,
      duration_according_to_map: durationAccordingToMap,
      start_date: startDate,
      end_date: endDate,
      lesson_quantity: lessonQuantity,
      extra_time_reason: extraTimeReason,
      number_of_absents: numberOfAbsents,
      number_of_absents_in_lessons: numberOfAbsentsInLessons,
      remarks: remarks,
    };

    await fetch(`${baseUrl}/hifz-exam-student-progress`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setAddLoading(false);
            setAddModal(false);
            setParaNumber("");
            setDurationAccordingToMap("");
            setLessonQuantity("");
            setStartDate("");
            setEndDate("");
            setExtraTimeReason("");
            setNumberOfAbsents("");
            setNumberOfAbsentsInLessons("");
            setRemarks("");
            console.log(searchText);
            alert.success("Add Progress Successfully!!");
            if (searchText != "") {
              searchByRegId(searchText);
            } else {
              handleShow();
            }
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setAddLoading(false);
            setAddModal(false);
          } else {
            alert.error("Something Went Wrong");
            setAddLoading(false);
            setAddModal(false);
          }
        })
      )
      .catch((err) => {
        setAddLoading(false);
        setAddModal(false);
        console.log(err);
      });
  };

  const getEditProgess = async (id) => {
    await fetch(`${baseUrl}/hifz-exam-student-progress/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditParaNumber(data.payload[0]?.para_number);
          setEditDurationAccordingToMap(
            data.payload[0]?.duration_according_to_map
          );
          setEditLessonQuantity(data.payload[0]?.lesson_quantity);
          setEditStartDate(data.payload[0]?.start_date);
          setEditEndDate(data.payload[0]?.end_date);
          setEditExtraTimeReason(data.payload[0]?.extra_time_reason);
          setEditNumberOfAbsents(data.payload[0]?.number_of_absents);
          setEditNumberOfAbsentsInLessons(
            data.payload[0]?.number_of_absents_in_lessons
          );
          setEditRemarks(data.payload[0]?.remarks);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateProgress = async () => {
    if (
      editParaNumber == "" ||
      editDurationAccordingToMap == "" ||
      editLessonQuantity == "" ||
      editStartDate == "" ||
      editEndDate == "" ||
      editExtraTimeReason == "" ||
      editNumberOfAbsents == "" ||
      editNumberOfAbsentsInLessons == "" ||
      editRemarks == ""
    ) {
      setisallfields(true);
      return;
    }
    setEditLoading(true);
    setisallfields(false);
    const data = {
      student_id: selectedStudent?.id,
      year_id: selectedStudent.session_id,
      campus_id: selectedStudent.campus_id,
      student_class_id: selectedStudent.student_class_id,
      global_section_id: selectedStudent.global_section_id,
      para_number: editParaNumber,
      duration_according_to_map: editDurationAccordingToMap,
      start_date: editStartDate,
      end_date: editEndDate,
      lesson_quantity: editLessonQuantity,
      extra_time_reason: editExtraTimeReason,
      number_of_absents: editNumberOfAbsents,
      number_of_absents_in_lessons: editNumberOfAbsentsInLessons,
      remarks: editRemarks,
    };

    await fetch(`${baseUrl}/hifz-exam-student-progress/${editProgressID}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setEditLoading(false);
            setEditModal(false);
            setShowModal(false);
            alert.success("Student Progress successfully Updated");
            if (searchText != "") {
              searchByRegId(searchText);
            } else {
              handleShow();
            }
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setShowModal(false);
            setEditLoading(false);
            setEditModal(false);
          } else {
            alert.show("Something Went Wrong");
            setShowModal(false);
            setEditLoading(false);
            setEditModal(false);
          }
        })
      )
      .catch((err) => {
        setEditLoading(false);
        setEditModal(false);
        console.log(err);
      });
  };

  const deleteProgress = async () => {
    setDeleteLoading(true);

    await fetch(`${baseUrl}/hifz-exam-student-progress/${deleteableProgress}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setDeleteLoading(false);
            setDeleteModal(false);
            setShowModal(false);
            alert.success(data.metadata.message);
            if (searchText != "") {
              searchByRegId(searchText);
            } else {
              handleShow();
            }
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setShowModal(false);
            setDeleteLoading(false);
            setDeleteModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setShowModal(false);
          setDeleteLoading(false);
          setDeleteModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setDeleteLoading(false);
        setDeleteModal(false);
      });
  };
  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-5">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => setYearId(e.target.value)}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item) => (
                    <option value={item.id}>{item.year}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Campus</b>
            </label>
            <select
              className="form-select"
              name="campus_id"
              value={selectedCampus}
              onChange={(e) => onCampusChange(e.target.value)}
              style={{ height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {campus.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class</b>
            </label>
            <select
              className="form-select"
              name="class_id"
              style={{ height: 40 }}
              aria-label="Default select example"
              value={selectedClass}
              onChange={(e) => onClassChange(e.target.value)}
            >
              <option value="">Select Class</option>
              {classes &&
                classes.map((sclass, index) => (
                  <>
                    <option key={index} value={sclass.id}>
                      {sclass.name}
                    </option>
                  </>
                ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Education Type</b>
            </label>
            <select
              className="form-select"
              name="campus_id"
              value={educationType}
              style={{ height: 40 }}
              aria-label="Default select example"
              onChange={(e) => {
                setEducationType(e.target.value);
              }}
              disabled
            >
              <option value={1}>Education</option>
              <option value={2}>Hifz</option>
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section</b>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="section_id"
              value={selectedSection}
              aria-label="Default select example"
              onChange={(e) => setSelectedSection(e.target.value)}
            >
              <option value="">Select Section</option>

              {sectionData &&
                sectionData?.map((item) => (
                  <option value={item.id}>{item.name}</option>
                ))}
            </select>
          </div>
          <div className="col-md-1 mt-12">
            <button
              disabled={!PremissionChecker(user, "student.show")}
              className="btn btn-primary"
              onClick={handleShow}
            >
              Show
            </button>
          </div>
          <div className="col-md-4 mt-14 d-flex">
            <div className="ml-5">
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single">
                <input
                  checked={printEmpty}
                  type="checkbox"
                  onChange={(e) => setPrintEmpty(e.target.checked)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Print Empty
              </label>
            </div>
          </div>
        </div>
        <form onSubmit={handleSearchSubmit}>
          <div className="row mt-5">
            <div className="col-md-4">
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="form-control"
                placeholder="Enter Name or Admission ID"
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn-primary">
                Search
              </button>
            </div>
          </div>
        </form>

        {/* student table  */}
        <Table responsive>
          <thead>
            <tr id="tbl" className="text-center">
              <th>Sr.No</th>
              <th>Admission ID</th>
              <th className="text-start">Student Name</th>
              <th className="text-start">Father Name</th>
              <th className="text-start">Class Section</th>
              <th>Joining Date</th>
              <th>Add Progress</th>
              <th>Add Record</th>
              <th>View</th>
              <th>Print</th>
            </tr>
          </thead>

          <tbody>
            {_DATA.currentData().map((student, index) => {
              return (
                // key={index}
                <tr key={index}>
                  <td>{student.SrNo}</td>
                  <td className="text-center ">{student?.admission_id}</td>
                  <td
                    title={student.name.length > 15 ? student.name : null}
                    style={{ textAlign: "start", cursor: "pointer" }}
                  >
                    {student.name}
                  </td>
                  <td
                    title={
                      student.father_name.length > 15
                        ? student.father_name
                        : null
                    }
                    style={{ textAlign: "start", cursor: "pointer" }}
                  >
                    {student.father_name.length > 15
                      ? student.father_name.substring(0, 12) + "..."
                      : student.father_name}
                  </td>
                  <td style={{ textAlign: "start" }}>
                    {student?.student_class?.name}&nbsp;
                    {student?.global_section?.name}&nbsp; (
                    {student?.campus?.name})
                  </td>
                  <td className="text-center ">{student?.Joining_date}</td>

                  <td style={{ paddingLeft: "0px" }} className="text-center">
                    <a
                      key={index}
                      className="btn btn-icon btn-light btn-hover-primary-custom btn-sm "
                      onClick={(e) => {
                        setSelectedStudent(student);
                        setAddModal(true);
                      }}
                    >
                      <span
                        key={index}
                        className="svg-icon svg-icon-md svg-icon-primary-custom"
                      >
                        <SVG
                          key={index}
                          src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                        />
                      </span>
                    </a>
                  </td>

                  <td style={{ paddingLeft: "0px" }} className="text-center">
                    <a
                      key={index}
                      className="btn btn-icon btn-light btn-hover-primary-custom btn-sm "
                      onClick={(e) => {
                        setSelectedStudent(student);
                        getStudentRecord(student?.id);
                        setAddHifzModal(true);
                      }}
                    >
                      <span
                        key={index}
                        className="svg-icon svg-icon-md svg-icon-primary-custom"
                      >
                        <SVG
                          key={index}
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Save.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>

                  <td className="text-center">
                    <a
                      style={{}}
                      className="btn btn-icon btn-light btn-hover-primary-custom btn-sm "
                      onClick={() => goToViewModal(student)}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Devices/Display2.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>

                  <td className="text-center">
                    <ReactToPrint
                      pageStyle={pageStyle}
                      documentTitle="Hifz Result"
                      onAfterPrint={handleAfterPrint}
                      onBeforePrint={handleBeforePrint}
                      removeAfterPrint={true}
                      content={() => componentRef.current}
                      onBeforeGetContent={() => {
                        return new Promise((resolve) => {
                          setSelectedStudent(student);
                          getStudentRecord(student?.id);
                          getStudentProgess(student.admission_id).then(() => {
                            // allow React to update with new data
                            setTimeout(resolve, 500); // optional delay to ensure render
                          });
                        });
                      }}
                      trigger={() => (
                        <a className="btn btn-icon btn-light btn-hover-primary-custom btn-sm">
                          <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                            <SVG
                              style={{ margin: "10px" }}
                              className="logouticone"
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Devices/Printer.svg"
                              )}
                            />
                          </span>
                        </a>
                      )}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        <Pagination
          color="text-primary"
          count={count}
          size="large"
          page={page}
          variant="text"
          shape="round"
          onChange={handleChange}
        />

        {/* For Print */}
        <div
          ref={componentRef}
          id="printSection"
          style={{ visibility: "hidden" }}
        >
          <div
            className="p-3"
            style={{
              display: "flex",
              direction: "rtl",
              fontFamily: "'Jameel Noori Nastaleeq', serif",
              textAlign: "right",
              // flexDirection: "column", // Important for layout consistency
            }}
          >
            <img style={{ height: 110, width: 100 }} src={icon} alt="logo" />

            <div className="col-md-12">
              <h1
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                }}
              >
                {unitName}
              </h1>
              <h2 className="text-center">
                <b>انفرادی تجزیہ: شعبہ حفظ القرآن</b>
              </h2>

              <div className="d-flex justify-content-between mb-2">
                <h5>
                  <b>
                    نام طالب علم بمعہ ولدیت:{" "}
                    <span style={englishText}>
                      {selectedStudent?.name} - {selectedStudent?.father_name}
                    </span>
                  </b>
                </h5>
                <h5>
                  <b>
                    کلاس (سیکشن):{" "}
                    <span style={englishText}>
                      {selectedStudent?.student_class?.name} (
                      {selectedStudent?.global_section?.name})
                    </span>
                  </b>
                </h5>
                <h5>
                  <b>
                    کیمپس:{" "}
                    <span style={englishText}>
                      {selectedStudent?.campus?.name}
                    </span>
                  </b>
                </h5>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <h5>
                  <b>
                    ایڈریس:{" "}
                    <span style={englishText}>{selectedStudent?.address}</span>
                  </b>
                </h5>
                <h5>
                  <b>
                    ایڈمیشن نمبر:{" "}
                    <span style={englishText}>
                      {selectedStudent?.admission_id}
                    </span>
                  </b>
                </h5>
                <h5>
                  <b>
                    تاریخ داخلہ:{" "}
                    <span style={englishText}>
                      {selectedStudent?.Joining_date}
                    </span>
                  </b>
                </h5>
              </div>

              <div className="d-flex justify-content-between">
                <h5>
                  <b>
                    سابقہ سکول / مدرسہ:{" "}
                    <span style={englishText}>
                      {studentRecordsData?.previous_school
                        ? studentRecordsData?.previous_school
                        : "---"}
                    </span>
                  </b>
                </h5>
                <h5>
                  <b>
                    سابقہ حفظ شدہ پارے:{" "}
                    <span style={englishText}>
                      {studentRecordsData?.previous_hifz_paray
                        ? studentRecordsData?.previous_hifz_paray
                        : "---"}
                    </span>
                  </b>
                </h5>
                <h5>
                  <b>
                    رابطہ نمبر:{" "}
                    <span className="english-text" style={englishText}>
                      {selectedStudent?.mobile_no}
                    </span>
                  </b>
                </h5>
              </div>
            </div>
          </div>

          <Table
            dir="rtl"
            style={{
              borderCollapse: "collapse",
              width: "100%",
              textAlign: "center",
              border: "1px solid black",
              fontFamily: "'Jameel Noori Nastaleeq', serif",
            }}
          >
            <thead>
              <tr>
                <th style={headCellStyle}>پارہ نمبر</th>
                <th style={headCellStyle}>مدت بمطابق معیادی نقشہ</th>
                <th style={headCellStyle}>سبق کی مقدار</th>
                <th style={headCellStyle}>تاریخ آغاز</th>
                <th style={headCellStyle}>تاریخ اختتام</th>
                <th style={headCellStyle}>زیادہ وقت کی وجہ</th>
                <th style={headCellStyle}>تعداد غیر حاضری</th>
                <th style={headCellStyle}>تعداد ناغہ سبق</th>
                <th style={headCellStyle}>ٹیسٹ کیفیت</th>
                <th style={headCellStyle}>دستخط ممتحن</th>
                <th style={headCellStyle}>دستخط پر نسپل</th>
                <th style={headCellStyle}>دستخط والدین</th>
              </tr>
            </thead>
            <tbody>
              {studentProgessData?.data?.map((item, index) => (
                <tr key={item.id}>
                  <td style={bodyCellStyle}>
                    {item?.para_number == "nurani_qida_namaz"
                      ? "نورانی قاعدہ + نماز"
                      : item?.para_number}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.duration_according_to_map}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.lesson_quantity}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.start_date}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.end_date}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.extra_time_reason}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.number_of_absents}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.number_of_absents_in_lessons}
                  </td>
                  <td style={bodyCellStyle}>
                    {printEmpty ? "" : item?.remarks}
                  </td>
                  <td style={bodyCellStyle}></td>
                  <td style={bodyCellStyle}></td>
                  <td style={bodyCellStyle}></td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div
            className="pl-3 pr-3"
            style={{
              direction: "rtl",
              fontFamily: "'Jameel Noori Nastaleeq', serif",
              textAlign: "right",
              // flexDirection: "column", // Important for layout consistency
            }}
          >
            <div className="d-flex justify-content-between">
              <h5>
                <b>
                  اختتامی تفصیلی کلمات(ازپرنسپل):{" "}
                  <span style={englishText}>
                    {studentRecordsData?.principle_remarks
                      ? studentRecordsData?.principle_remarks
                      : "---"}
                  </span>
                </b>
              </h5>
            </div>

            <div className="d-flex justify-content-between">
              <h5>
                <b>
                  ٹوٹل غیر حاضری:{" "}
                  <span style={englishText}>
                    {studentProgessData?.total_absents
                      ? studentProgessData?.total_absents
                      : "---"}
                  </span>
                </b>
              </h5>
              <h5>
                <b>
                  ٹوٹل سبق ناغہ:{" "}
                  <span style={englishText}>
                    {studentProgessData?.total_lesson_absents
                      ? studentProgessData?.total_lesson_absents
                      : "---"}
                  </span>
                </b>
              </h5>
              <h5>
                <b>
                  حفظ قرآن کی مدت:{" "}
                  <span style={englishText}>
                    {studentRecordsData?.hifz_quran_duration
                      ? studentRecordsData?.hifz_quran_duration
                      : "---"}
                  </span>
                </b>
              </h5>
              <h5>
                <b>
                  تکمیل قرآن کے وقت کلاس :{" "}
                  <span className="english-text" style={englishText}>
                    {studentRecordsData?.student_class?.name
                      ? studentRecordsData?.student_class?.name
                      : "---"}
                  </span>
                </b>
              </h5>
            </div>

            <div className="d-flex justify-content-between">
              <h5>
                <b>
                  دستخط:
                  <span
                    style={{
                      ...englishText,
                      // textDecoration: "none", // remove this if you're just doing underline via border
                      borderBottom: "1px solid black",
                      display: "inline-block",
                      width: "150px",
                      marginLeft: "10px",
                    }}
                  ></span>
                </b>
              </h5>
              <h5>
                <b>
                  تاریخ:{" "}
                  <span className="english-text" style={englishText}>
                    {studentRecordsData?.completion_date
                      ? studentRecordsData?.completion_date
                      : "---"}
                  </span>
                </b>
              </h5>
            </div>
          </div>
        </div>

        {/* View Progress Modal */}
        <Modal show={showModal} size="xl">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Student Progress Report | {selectedStudent.name} (
              {selectedStudent.admission_id})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="card mt-5 text-custom-primary">
              <h2 className="mb-8 text-decoration-underline">
                Personal Details
              </h2>
              <div className=" col-md-12 d-flex ">
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Name : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.name == undefined
                          ? null
                          : selectedStudent.name.length > 20
                          ? selectedStudent.name
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.name == undefined
                        ? null
                        : " " + selectedStudent.name}
                    </h5>
                  </div>
                </div>
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Father Name : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.father_name == undefined
                          ? null
                          : selectedStudent.father_name.length > 15
                          ? selectedStudent.father_name
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.father_name == undefined
                        ? null
                        : " " + selectedStudent.father_name}
                    </h5>
                  </div>
                </div>
              </div>

              <hr />
              <div className=" col-md-12 d-flex ">
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Date of Birth : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.dob == undefined
                          ? null
                          : selectedStudent.dob.length > 15
                          ? selectedStudent.dob
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.dob == undefined
                        ? null
                        : " " + selectedStudent.dob}
                    </h5>
                  </div>
                </div>
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>
                      {selectedStudent?.admission_id == null ? (
                        <>Registration ID : &ensp;</>
                      ) : (
                        <>Admission ID : &ensp;</>
                      )}{" "}
                    </h5>
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.admission_id == undefined ||
                        selectedStudent.admission_id == null
                          ? selectedStudent?.registration_id
                          : selectedStudent.admission_id
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.admission_id == undefined ||
                      selectedStudent.admission_id == null
                        ? " " + selectedStudent?.registration_id
                        : " " + selectedStudent.admission_id}
                    </h5>
                  </div>
                </div>
              </div>

              <hr />
              <div className=" col-md-12 d-flex ">
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Gender : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.gender == undefined
                          ? null
                          : selectedStudent.gender.length > 15
                          ? selectedStudent.gender
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.gender == undefined
                        ? null
                        : selectedStudent.gender.length > 15
                        ? " " + selectedStudent.gender.substring(0, 12) + "..."
                        : " " + selectedStudent.gender}
                    </h5>
                  </div>
                </div>
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Mobile No# : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.mobile_no == undefined
                          ? null
                          : selectedStudent.mobile_no.length > 15
                          ? selectedStudent.mobile_no
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.mobile_no == undefined
                        ? null
                        : " " + selectedStudent.mobile_no}
                    </h5>
                  </div>
                </div>
              </div>

              <hr />
              <div className=" col-md-12 d-flex ">
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Class : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.student_class?.name == undefined
                          ? null
                          : selectedStudent.student_class?.name.length > 15
                          ? selectedStudent.student_class?.name
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.student_class?.name == undefined
                        ? null
                        : " " + selectedStudent.student_class?.name}
                    </h5>
                  </div>
                </div>
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Section: &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent?.global_section?.name == undefined
                          ? null
                          : selectedStudent?.global_section?.name.length > 15
                          ? selectedStudent?.global_section?.name
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent?.global_section?.name == undefined
                        ? " " + "---"
                        : " " + selectedStudent?.global_section?.name}
                    </h5>
                  </div>
                </div>
              </div>

              <hr />
              <div className=" col-md-12 d-flex ">
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Joining date : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent?.Joining_date == undefined
                          ? null
                          : selectedStudent?.Joining_date.length > 15
                          ? selectedStudent?.Joining_date
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent?.Joining_date == undefined
                        ? null
                        : " " + selectedStudent?.Joining_date}
                    </h5>
                  </div>
                </div>
                <div className=" col-md-6 d-flex ">
                  <div>
                    {" "}
                    <h5>Father CNIC# : &ensp;</h5>{" "}
                  </div>
                  <div>
                    <h5
                      title={
                        selectedStudent.father_cnic == undefined
                          ? null
                          : selectedStudent.father_cnic.length > 15
                          ? selectedStudent.father_cnic
                          : null
                      }
                      style={{
                        color: "grey",
                        textAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {selectedStudent.father_cnic == undefined
                        ? null
                        : " " + selectedStudent.father_cnic}
                    </h5>
                  </div>
                </div>
              </div>

              <hr />
              <div className="col-md-12 d-flex">
                <div className="col d-flex">
                  <h5>Address: &ensp;</h5>{" "}
                  {/* <h5>{selectedStudent.name}</h5> */}
                  <h5
                    title={
                      selectedStudent.address == undefined
                        ? null
                        : selectedStudent.address
                    }
                    style={{
                      color: "grey",
                      textAlign: "start",
                      cursor: "pointer",
                    }}
                  >
                    {" "}
                    {selectedStudent.address == undefined
                      ? null
                      : selectedStudent.address}
                  </h5>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="d-flex justify-content-between">
                <h2 className="text-decoration-underline">
                  Hifz Student Progress History
                </h2>
                <ReactToPrint
                  pageStyle={pageStyle}
                  documentTitle="Print Progress Report"
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary"
                    >
                      {printloading ? "Printing..." : "Print Progress"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />
              </div>
              <Table responsive style={{ width: "max-content" }}>
                <thead>
                  <tr id="tbl">
                    <th>Para Number</th>
                    <th>Duration According To Map</th>
                    <th>Lesson Quantity</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Extra Time Reason</th>
                    <th>Number Of Absents</th>
                    <th>Number Of Absents In Lessons</th>
                    <th>Remarks</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>

                <tbody>
                  {studentProgessData?.data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item?.para_number == "nurani_qida_namaz"
                          ? "نورانی قاعدہ + نماز"
                          : item?.para_number}
                      </td>
                      <td>{item?.duration_according_to_map}</td>
                      <td>{item?.lesson_quantity}</td>
                      <td>{item?.start_date}</td>
                      <td>{item?.end_date}</td>
                      <td>{item?.extra_time_reason}</td>
                      <td>{item?.number_of_absents}</td>
                      <td>{item?.number_of_absents_in_lessons}</td>
                      <td>{item?.remarks}</td>
                      <td>
                        <a
                          className={
                            "btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                          }
                          onClick={() => {
                            getEditProgess(item?.id);
                            setEditProgressID(item?.id);
                            setEditModal(true);
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary-custom ">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Write.svg"
                              )}
                            />
                          </span>
                        </a>
                      </td>
                      <td>
                        <a
                          className={
                            "btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                          }
                          onClick={() => {
                            setDeleteableProgress(item?.id);
                            setDeleteModal(true);
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Delete-user.svg"
                              )}
                            />
                          </span>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger btn_width"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Add Hifz Student Record Modal */}
        <Modal show={addHifzModal} size="xl">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Hifz Student Record | {selectedStudent.name} (
              {selectedStudent.admission_id})
            </Modal.Title>
          </Modal.Header>
          {addLoading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Student Record Adding Please Wait...{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Body>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <label>
                    <b>Select Hifz End Class</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="para_number"
                    value={hifzEndClassId}
                    aria-label="Default select example"
                    onChange={(e) => setHifzEndClassId(e.target.value)}
                  >
                    <option value="">Select Hifz End Class</option>
                    {classesData &&
                      classesData?.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                  </select>
                </div>

                <div className="col-md-6 mb-4">
                  <label>
                    <b>Enter Previous School</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={previousSchool}
                    onChange={(e) => setPreviousSchool(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Previous School"
                  />
                </div>

                <div className="col-md-6 mb-4">
                  <label>
                    <b>Enter Previous Hifz Paray</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={previousHifzParay}
                    onChange={(e) => setPreviousHifzParay(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Previous Hifz Paray"
                  />
                </div>

                <div className="col-md-6 mb-4">
                  <label>
                    <b>Enter Hifz Quran Duration</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={hifzQuranDuration}
                    onChange={(e) => setHifzQuranDuration(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Hifz Quran Duration"
                  />
                </div>

                <div className="col-md-6 mb-4">
                  <label>
                    <b>
                      Select Completion Date{" "}
                      <span style={{ color: "red", fontSize: 12 }}>*</span>
                    </b>
                  </label>
                  <input
                    className="form-control"
                    value={completionDate}
                    onChange={(e) => setCompletionDate(e.target.value)}
                    type="date"
                  />
                </div>

                <div className="col-md-6 mb-4">
                  <label>
                    <b>Enter Principle Remarks</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={principleRemarks}
                    onChange={(e) => setPrincipleRemarks(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Principle Remarks"
                  />
                </div>
              </div>

              <br />
            </Modal.Body>
          )}

          <Modal.Footer>
            <button
              className="btn btn-primary"
              onClick={addHifzRecord}
              disabled={addLoading ? true : false}
            >
              Save
            </button>
            <button
              className="btn btn-danger"
              onClick={() => {
                setAddHifzModal(false);
                setisallfields(false);
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Add Progress Modal */}
        <Modal show={addModal} size="xl">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Student Progress | {selectedStudent.name} (
              {selectedStudent.admission_id})
            </Modal.Title>
          </Modal.Header>
          {addLoading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Progress Adding Please Wait...{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Body>
              <div className="row">
                <div className="col-md-4 mb-4">
                  <label>
                    <b>Select Para Number</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="para_number"
                    value={paraNumber}
                    aria-label="Default select example"
                    onChange={(e) => setParaNumber(e.target.value)}
                  >
                    <option value="">Select Para Number</option>
                    <option value="nurani_qida_namaz">
                      Nurani Qida + Namaz
                    </option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                  </select>
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Duration According To Set Standard</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={durationAccordingToMap}
                    onChange={(e) => setDurationAccordingToMap(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Duration"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Lesson Quantity</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={lessonQuantity}
                    onChange={(e) => setLessonQuantity(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Lesson Quantity"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>
                      Select Start Date{" "}
                      <span style={{ color: "red", fontSize: 12 }}>*</span>
                    </b>
                  </label>
                  <input
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    type="date"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>
                      Select End Date{" "}
                      <span style={{ color: "red", fontSize: 12 }}>*</span>
                    </b>
                  </label>
                  <input
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    type="date"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Extra Time Reason</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={extraTimeReason}
                    onChange={(e) => setExtraTimeReason(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Extra Time Reason"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Number Of Absents</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={numberOfAbsents}
                    onChange={(e) => setNumberOfAbsents(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Number Of Absents"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Number Of Absents In Lessons</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={numberOfAbsentsInLessons}
                    onChange={(e) =>
                      setNumberOfAbsentsInLessons(e.target.value)
                    }
                    name="total_marks"
                    placeholder="Enter Number Of Absents In Lessons"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Remarks</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Number Of Absents In Lessons"
                  />
                </div>
              </div>

              <br />
              <br />
              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>Please fill or select all fields</p>
                  </Alert>
                </>
              ) : null}
            </Modal.Body>
          )}

          <Modal.Footer>
            <button
              className="btn btn-primary"
              onClick={addProgress}
              disabled={addLoading ? true : false}
            >
              Add Progress
            </button>
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddModal(false);
                setisallfields(false);
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Progress Modal */}
        <Modal show={editModal} size="xl">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Edit Student Progress | {selectedStudent.name} (
              {selectedStudent.admission_id})
            </Modal.Title>
          </Modal.Header>
          {addLoading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Progress Updating Please Wait...{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Body>
              <div className="row">
                <div className="col-md-4 mb-4">
                  <label>
                    <b>Select Para Number</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="para_number"
                    value={editParaNumber}
                    aria-label="Default select example"
                    onChange={(e) => setEditParaNumber(e.target.value)}
                  >
                    <option value="">Select Para Number</option>
                    <option value="nurani_qida_namaz">
                      Nurani Qida + Namaz
                    </option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                  </select>
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Duration According To Set Standard</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editDurationAccordingToMap}
                    onChange={(e) =>
                      setEditDurationAccordingToMap(e.target.value)
                    }
                    name="total_marks"
                    placeholder="Enter Duration"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Lesson Quantity</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editLessonQuantity}
                    onChange={(e) => setEditLessonQuantity(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Lesson Quantity"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>
                      Select Start Date{" "}
                      <span style={{ color: "red", fontSize: 12 }}>*</span>
                    </b>
                  </label>
                  <input
                    className="form-control"
                    value={editStartDate}
                    onChange={(e) => setEditStartDate(e.target.value)}
                    type="date"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>
                      Select End Date{" "}
                      <span style={{ color: "red", fontSize: 12 }}>*</span>
                    </b>
                  </label>
                  <input
                    className="form-control"
                    value={editEndDate}
                    onChange={(e) => setEditEndDate(e.target.value)}
                    type="date"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Extra Time Reason</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editExtraTimeReason}
                    onChange={(e) => setEditExtraTimeReason(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Extra Time Reason"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Number Of Absents</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={editNumberOfAbsents}
                    onChange={(e) => setEditNumberOfAbsents(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Number Of Absents"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Number Of Absents In Lessons</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={editNumberOfAbsentsInLessons}
                    onChange={(e) =>
                      setEditNumberOfAbsentsInLessons(e.target.value)
                    }
                    name="total_marks"
                    placeholder="Enter Number Of Absents In Lessons"
                  />
                </div>

                <div className="col-md-4 mb-4">
                  <label>
                    <b>Enter Remarks</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editRemarks}
                    onChange={(e) => setEditRemarks(e.target.value)}
                    name="total_marks"
                    placeholder="Enter Number Of Absents In Lessons"
                  />
                </div>
              </div>

              <br />
              <br />
              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>Please fill or select all fields</p>
                  </Alert>
                </>
              ) : null}
            </Modal.Body>
          )}

          <Modal.Footer>
            <button
              className="btn btn-primary"
              onClick={updateProgress}
              disabled={editLoading ? true : false}
            >
              Update Progress
            </button>
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setEditModal(false);
                setisallfields(false);
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Progress Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this student progress?
            </Modal.Title>
          </Modal.Header>
          {deleteLoading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Student Progress Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={deleteProgress} className="btn button_blue">
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setDeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default HifzProgressReport;
